'use client';

import React, { forwardRef } from 'react';

import SearchIcon from '@mui/icons-material/Search';

const DEFAULT_SORT_OPTIONS = [
  { value: 'alphabetical', label: 'Alphabetized' },
  { value: 'created', label: 'Created Date/Time' },
  { value: 'modified', label: 'Modified Date/Time' },
  { value: 'mostUsed', label: 'Most Used' },
  { value: 'lastUsed', label: 'Last Used' },
];

const SearchAndSortControls = forwardRef(function SearchAndSortControls(
  {
    onSearch,
    onKeyDown,
    onSortChange,
    onSortDirectionChange,
    placeholder = 'Search...',
    sortBy,
    sortDirection,
    sortOptions = DEFAULT_SORT_OPTIONS,
    rightContent,
  },
  ref
) {
  return (
    <div className="search-and-sort-controls">
      <div className="search-and-sort-controls__row">
        <div className="search-and-sort-controls__input-wrapper">
          <SearchIcon className="search-icon" fontSize="small" />
          <input
            ref={ref}
            type="search"
            className="search-and-sort-controls__input"
            placeholder={placeholder}
            onChange={(e) => onSearch(e.target.value)}
            onKeyDown={onKeyDown}
            aria-label={placeholder}
          />
        </div>
      </div>
      <div className="search-and-sort-controls__row">
        <select
          className="search-and-sort-controls__select"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
          aria-label="Sort by"
        >
          {sortOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="search-and-sort-controls__direction"
          onClick={() =>
            onSortDirectionChange(sortDirection === 'asc' ? 'desc' : 'asc')
          }
          aria-label={
            sortDirection === 'asc' ? 'Switch to descending sort' : 'Switch to ascending sort'
          }
        >
          {sortDirection === 'asc' ? '↑' : '↓'}
        </button>
        {rightContent}
      </div>
    </div>
  );
});

export default SearchAndSortControls;
